import {
  GET_TRADED_AMOUNTS,
  GET_TRADED_AMOUNTS_ERROR,
  GET_TRADED_AMOUNTS_SUCCESS
} from './ContingenciesTradedAmountsSection.actions'

const initialState = {
  data: { chartStructure: [], csvStructure: [] },
  error: null,
  loading: false
}

/**
 * contingenciesTradedAmounts's reducer.
 */
const contingenciesTradedAmounts = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_TRADED_AMOUNTS: {
      return { ...state, loading: true }
    }
    case GET_TRADED_AMOUNTS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_TRADED_AMOUNTS_SUCCESS: {
      return { ...state, data: payload, loading: false }
    }
    default: {
      return state
    }
  }
}

export default contingenciesTradedAmounts
